import React from 'react'
import { Link } from 'react-router-dom'
import service_1 from '../../../assets/images/services/services-two-1.png'
import service_2 from '../../../assets/images/services/services-two-2.jpg'
import service_3 from '../../../assets/images/services/services-two-3.jpg'

const Service = () => {
    return (
        <>
            <div className="service-section-two">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 m-auto">
                            <div className="heading-box light text-center">
                                <span
                                    className="sub-title animate fadeInUp wow"
                                    data-wow-duration="1500ms"
                                >
                                    Services
                                </span>
                                <h2
                                    className="heading-title animate fadeInUp wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="200ms"
                                >
                                    We are building great future together Be with us
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row gutter-y-30">
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="service-box-two animate fadeInUp wow"
                                data-wow-duration="1500ms"
                            >
                                <div className="service-image-two">
                                    <img
                                        src={service_1}
                                        alt="service-image"
                                    />
                                    <div className="service-icon-two">
                                        <svg
                                            width={45}
                                            height={47}
                                            viewBox="0 0 45 47"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M42.2083 6.37476H2.79167C1.80216 6.37476 1 7.17691 1 8.16642V35.0414C1 36.0309 1.80216 36.8331 2.79167 36.8331H42.2083C43.1978 36.8331 44 36.0309 44 35.0414V8.16642C44 7.17691 43.1978 6.37476 42.2083 6.37476Z"
                                                stroke="#1B2429"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M29.666 36.8333L36.8327 45.7916"
                                                stroke="#1B2429"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M15.3327 36.8333L8.16602 45.7916"
                                                stroke="#1B2429"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M15.334 22.5V27.875"
                                                stroke="#1B2429"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M22.5 18.9165V27.8748"
                                                stroke="#1B2429"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M29.666 15.3333V27.8749"
                                                stroke="#1B2429"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M22.5 6.375V1"
                                                stroke="#1B2429"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </div>
                                </div>
                                <div className="service-details-two">
                                    <h4>
                                        <Link to="/ServiceDetails">Business Analysis</Link>
                                    </h4>
                                    <p>
                                        We guarantee to provide affordable business consulting solutions
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="service-box-two animate fadeInUp wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="400ms"
                            >
                                <div className="service-image-two">
                                    <img
                                        src={service_2}
                                        alt="service-image"
                                    />
                                    <div className="service-icon-two">
                                        <svg
                                            width={54}
                                            height={54}
                                            viewBox="0 0 54 54"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M30.375 6.75H23.625C22.693 6.75 21.9375 7.50552 21.9375 8.4375V15.1875C21.9375 16.1195 22.693 16.875 23.625 16.875H30.375C31.307 16.875 32.0625 16.1195 32.0625 15.1875V8.4375C32.0625 7.50552 31.307 6.75 30.375 6.75Z"
                                                stroke="#1B2429"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M16.875 35.4375H10.125C9.19302 35.4375 8.4375 36.193 8.4375 37.125V43.875C8.4375 44.807 9.19302 45.5625 10.125 45.5625H16.875C17.807 45.5625 18.5625 44.807 18.5625 43.875V37.125C18.5625 36.193 17.807 35.4375 16.875 35.4375Z"
                                                stroke="#1B2429"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M43.875 35.4375H37.125C36.193 35.4375 35.4375 36.193 35.4375 37.125V43.875C35.4375 44.807 36.193 45.5625 37.125 45.5625H43.875C44.807 45.5625 45.5625 44.807 45.5625 43.875V37.125C45.5625 36.193 44.807 35.4375 43.875 35.4375Z"
                                                stroke="#1B2429"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M27 16.875V25.3125"
                                                stroke="#1B2429"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M40.5 25.3125V35.4375"
                                                stroke="#1B2429"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M13.5 35.4375V25.3125"
                                                stroke="#1B2429"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M5.0625 25.3125H48.9375"
                                                stroke="#1B2429"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </div>
                                </div>
                                <div className="service-details-two">
                                    <h4>
                                        <Link to="/ServiceDetails">Work organization</Link>
                                    </h4>
                                    <p>Our solutions are scalable and can grow with your business</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="service-box-two animate fadeInUp wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="800ms"
                            >
                                <div className="service-image-two">
                                    <img
                                        src={service_3}
                                        alt="service-image"
                                    />
                                    <div className="service-icon-two">
                                        <svg
                                            width={45}
                                            height={47}
                                            viewBox="0 0 45 47"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M42.2083 6.37476H2.79167C1.80216 6.37476 1 7.17691 1 8.16642V35.0414C1 36.0309 1.80216 36.8331 2.79167 36.8331H42.2083C43.1978 36.8331 44 36.0309 44 35.0414V8.16642C44 7.17691 43.1978 6.37476 42.2083 6.37476Z"
                                                stroke="#1B2429"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M29.666 36.8333L36.8327 45.7916"
                                                stroke="#1B2429"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M15.3327 36.8333L8.16602 45.7916"
                                                stroke="#1B2429"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M15.334 22.5V27.875"
                                                stroke="#1B2429"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M22.5 18.9165V27.8748"
                                                stroke="#1B2429"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M29.666 15.3333V27.8749"
                                                stroke="#1B2429"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M22.5 6.375V1"
                                                stroke="#1B2429"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </div>
                                </div>
                                <div className="service-details-two">
                                    <h4>
                                        <Link to="/ServiceDetails">Digital marketing</Link>
                                    </h4>
                                    <p>
                                        Sed Perspiciatis unde Omnis Iste Sed ut Pers piciatis unde Omnis
                                        Ist
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div >
                </div >
            </div >

        </>
    )
}

export default Service
